<script lang="ts">
  import { focus } from "./actions/focus";
  import DialogBase from "./DialogBase.svelte";
  import { createQuatrixConfig } from "./fs";
  import { makeFileSystemQuatrix, quatrixHost, testQuatrixConnection } from "./fs-quatrix";
  import { captureEvent, telegramNotify } from "./http";
  import { showMessage } from "./message";

  interface Props {
    open?: boolean;
    mountfs: (fs: any) => void;
  }

  let { open = $bindable(false), mountfs }: Props = $props();

  let config = $state(createQuatrixConfig());
  let testingConnection = $state(false);
  let errorMessage = $state("");

  let canConnect = $derived(config.host.trim() != "" && config.apiKey.trim() != "" && !testingConnection);

  async function onConnect() {
    testingConnection = true;
    errorMessage = "";
    let removeMsg = showMessage("testing quatrix connection");
    try {
      config.apiKey = config.apiKey.trim();
      config.host = quatrixHost(config.host);
      config.name = config.name.trim();
      await testQuatrixConnection(config);
      if (config.name == "") {
        config.name = config.host;
      }
      let fs = makeFileSystemQuatrix(config);
      let who = config.host;
      telegramNotify(`New Quatrix connection for ${who}`);
      captureEvent("quatrix-login", {});
      removeMsg();
      mountfs(fs);
      open = false;
    } catch (e) {
      console.error(e);
      errorMessage = (e as Error).toString();
      removeMsg();
    }
    testingConnection = false;
  }

  function close() {
    open = false;
  }
</script>

<DialogBase bind:open title="Connect Quatrix">
  {#snippet main()}
    <div class="flex flex-col text-sm">
      <label for="input-quatrix-name">Name: <span class="text-gray-400">(optional)</span></label>
      <input
        use:focus
        type="text"
        id="input-quatrix-name"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.name}
      />

      <label class="mt-3" for="input-quatrix-host">Host:</label>
      <input
        type="text"
        id="input-quatrix-host"
        autocomplete="off"
        placeholder="mycompany.quatrix.it"
        class="outline-hidden border px-2 py-1"
        bind:value={config.host}
      />

      <label class="mt-3" for="input-quatrix-key">API key:</label>
      <input
        type="password"
        id="input-quatrix-key"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.apiKey}
      />

      <div class="mt-3 w-72 text-gray-500">
        The host is the address of your Quatrix account. Make an API key in Quatrix, in your profile, under API keys.
        <a href="/doc/Quatrix" class="text-blue-600 underline" target="_blank">More</a>
      </div>

      {#if errorMessage}
        <div class="mt-2 mb-2 w-72 font-medium break-all text-red-500">
          {errorMessage}
        </div>
      {/if}
    </div>
  {/snippet}

  {#snippet bottom()}
    <div class="flex flex-row justify-between">
      <button onclick={close} class="dlg-btn">Cancel</button>
      <button disabled={!canConnect} onclick={onConnect} class="dlg-btn">Connect Quatrix</button>
    </div>
  {/snippet}
</DialogBase>
